import { Link } from "react-router-dom";
import { MapPin, Mail } from "lucide-react";
import logoImg from "@/assets/logo.png";

const SITE_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/careers", label: "Careers" },
  { to: "/contact", label: "Contact" },
];

export const Footer = () => (
  <footer className="bg-ink text-cream border-t-[4px] border-brand-gold" data-testid="site-footer">
    <div className="px-6 lg:px-10 py-16 lg:py-20">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-cream/60">For more info, call the viaduct</p>
          <a
            href="tel:+18338123828"
            data-testid="footer-phone-link"
            className="block mt-3 font-display text-5xl md:text-7xl lg:text-8xl tracking-tight text-brand-gold underline decoration-[6px] underline-offset-8 decoration-transparent hover:decoration-brand-gold transition-[text-decoration-color] duration-200"
          >
            833-V1ADUCT
          </a>
          <p className="mt-3 text-lg text-cream/70">833-812-3828</p>
          <a
            href="mailto:office@memphisviaduct.com"
            data-testid="footer-email-link"
            className="mt-4 inline-flex items-center gap-2 text-lg text-cream/90 underline decoration-brand-gold decoration-2 underline-offset-4 transition-colors duration-200 hover:text-brand-gold"
          >
            <Mail size={18} aria-hidden="true" /> office@memphisviaduct.com
          </a>
        </div>
        <div className="flex items-center gap-4">
          <img
            src={logoImg}
            alt="Memphis Viaduct Inc badge"
            className="h-20 w-20 rounded-full object-cover border-[3px] border-cream/80"
          />
          <div>
            <p className="font-display text-2xl">MEMPHIS VIADUCT INC</p>
            <p className="text-brand-gold font-semibold uppercase tracking-[0.2em] text-xs mt-1">Your Road to Reliance</p>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-10 mt-14 pt-10 border-t border-cream/15">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-cream/50">Site</p>
          <ul className="mt-4 space-y-2">
            {SITE_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-${l.label.toLowerCase()}-link`}
                  className="font-display uppercase text-xl tracking-wide text-cream/90 hover:text-brand-gold transition-colors duration-200"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-cream/50">Divisions</p>
          <ul className="mt-4 space-y-2">
            <li>
              <Link to="/services" data-testid="footer-division-regional-link" className="font-display uppercase text-xl tracking-wide text-cream/90 hover:text-brand-gold transition-colors duration-200">
                Regional — Home Every Weekend
              </Link>
            </li>
            <li>
              <Link to="/services" data-testid="footer-division-otr-link" className="font-display uppercase text-xl tracking-wide text-cream/90 hover:text-brand-gold transition-colors duration-200">
                OTR — 2 Weeks Out, 3 Days Home
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-cream/50">Home Base</p>
          <p className="mt-4 flex items-start gap-2 text-cream/80 leading-relaxed">
            <MapPin size={20} className="mt-1 shrink-0 text-brand-gold" aria-hidden="true" />
            <span>
              The I-55 &amp; I-40 crossing point
              <br />
              on the Mississippi River bank
              <br />
              Memphis, Tennessee
            </span>
          </p>
          <p className="mt-4 text-cream/50 text-sm">Established 2025</p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-2 mt-14 border-t border-cream/15 pt-6 text-[11px] font-semibold uppercase tracking-[0.2em] text-cream/50">
        <span data-testid="footer-copyright">© 2025 Memphis Viaduct Inc — Memphis, Tennessee</span>
        <span>Your Road to Reliance</span>
      </div>
    </div>
  </footer>
);

export default Footer;
